<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "App",
  computed: {
    ...mapState("userinfo", ["isLocal"])
  },
  beforeCreate() {
    window.$vue = this;
  },
  created() {
    this.SystemFromReg();
    this.getUserInfo(); //获取用户消息
    this.isLogin(); //登陆问题
    this.getmeun(); //获取菜单
  },
  methods: {
    ...mapMutations("userinfo", [
      "isLogin",
      "getUserInfo",
      "getmeun",
      "getnowRouter",
      "setSystemFrom"
    ]),
    async SystemFromReg() {
      let token = window.localStorage.getItem("token");
      let loginType = window.localStorage.getItem("loginType");
      let urlLocal = this.GetQueryString("local");
      let autoCrmLogin = this.GetQueryString("autoCrmLogin");
      let ticket = this.GetQueryString("ticket");
      // console.log(ticket,'ticket');
      // console.log(urlLocal,'urlLocal');
      //带?autoCrmLogin自动登录
      if (autoCrmLogin) {
        console.log("当前登录方式：自动单点登录(crm登录)");
        this.setSystemFrom(false);
        location.href = `${this.config.crmLogin}/tologin.html?nextUrl=${this.config.HospitalManageFront}&from=HospitalManageFront`;
      } else if (ticket) {
        console.log("当前登录方式：自动单点登录(crm登录)");
        this.setSystemFrom(false);
        let res = await this.$post(
          `${this.config.interface}login/crmTicketLogin`,
          { ticket }
        );
        if (res.code && res.code == 200) {
          // window.localStorage.setItem('token',JSON.stringify(res.token));
          this.getUserInfo(res); //获取用户消息
          this.isLogin(); //登陆问题
          this.getmeun(); //获取菜单
          this.$router.push({ path: "/" });
        }
      } else if ((urlLocal || !loginType || loginType == "local") && !ticket) {
        console.log("当前登录方式：手动本地登录");
        this.setSystemFrom(true);
      } else {
        console.log("当前登录方式：手动单点登录(crm登录)");
        this.setSystemFrom(false);
      }
    }, //是否单点登录（来自crm）
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");

      var r = window.location.search.substr(1).match(reg);

      if (r != null) return unescape(r[2]);
      return null;
    }
  },
  watch: {
    $route(to, form) {
      this.getnowRouter(to.path); //获取当前路由权限
      window.$vue = this;
    }
  }
};
</script>
<style lang="less">
@import "../static/css/common";
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.phone-autocomplete-popup {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue